import React from "react";
import './index.scss'
import bti from '@src/assets/image/bottom-icon.png'
export default function() {
  return (
    <div className="bottom-icon">
      <img src={bti} alt=""></img>
    </div>
  )
}